import React, { useCallback, useContext, useEffect, useState } from "react";
import Information from "../../../../../images/Info.svg";
import { Button } from "../../../../../stories/Button/Button";
import { Label } from "../../../../../stories/Label/Label";
import Input from "../../../../../stories/Input/Input";
import {
  ImageModalStylesInTickets,
  VideoPreviewModalStyles,
  ViewTicketModalStyles,
  WaiveOffModalStyles,
} from "../../../../../styles/CustomModalStyles";
import Modal from "react-modal";
import { Title } from "../../../../../stories/Title/Title";
import Warning from "../../../../../images/Warning.svg";
import Close from "../../../../../images/Close.svg";
import { CustomTooltip } from "../../../../../styles/TooltipStyles";
import { TOOLTIP_COLORS } from "../../../../../styles/Variables";
import ViewAsset from "../../purchase/stockentry/ViewAsset";
import {
  convertToTimeZone,
  CustomModal,
  toIsoDate,
  toStandardDate,
} from "../../../../../utils/UtilFunctions";
import { MapsContext } from "../context/context";

import { useLazyQuery, useMutation } from "@apollo/client";
import {
  GetCompOrJuncOrAssetOrSubAndSiteNodeResult,
  GetCompOrJuncOrAssetOrSubAndSiteNodeVars,
} from "../../masters/items/queries/types";
import { CompOrJuncOrAssetOrSubAndSiteNode } from "../../masters/items/queries/queries";
import {
  allowedFormatsForTicket,
  EMPTY_STRING,
  emptyFunc,
  emptyMessage,
  imageFormats,
  ROWS_PER_PAGE,
  TicketStatus,
} from "../../../../../utils/constants";
import {
  IObjectKeys,
  TicketFormType,
  responseType,
} from "../../../../../utils/formTypes";
import useLabels from "../../../../../customHooks/useLabels";
import TextArea from "../../../../../stories/TextArea/TextArea";
import FileAttach from "../../../../../images/BrowseFiles.svg";
import Upload from "../../../../../images/Upload.svg";
import { msgType } from "../../../../../utils/types";
import useServerDateandTime from "../../../../../customHooks/useServerDateandTime";
import { Form, Formik } from "formik";
import useSqlNumber from "../../../../../customHooks/useSqlNumber";
import { raiseTicketValidation } from "../../../../../utils/validationSchema";
import { Operation, TimeZone, empType } from "../../../../../utils/Enum.types";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { AddTicket, GetTickets } from "../../../../../queries/queries";
import {
  AddTicketResult,
  AddTicketVars,
  AtsTicketsOrderField,
  TicketsQueryType,
} from "../../../../../queries/types";
import { handleUploadAndDownloadFile } from "../../../../../utils/Upload";
import MessageModal from "../../../../../customComponents/MessageModal";
import { TableType } from "../../../customer/companies/queries/types";

import Legends from "./junctionDetails/Legends";

import ViewJunctionDetails from "./junctionDetails/ViewJunctionDetails";
import JunctionDetails from "./junctionDetails/JunctionDetails";
import { AssetViewDrawer } from "../../../../../styles/CustomDrawerStyles";
import { StateTypes } from "../Maps";
import { AppContext } from "../../../../../context/context";
import { OrderDirection, nodeVar } from "../../../../../utils/commonQueryTypes";
import LoadingModal from "../../../../pages/LoadingModal";
import EmployeeSelect from "../../../../../customComponents/EmplayeeSelect";
import { EmpMaster, EmpQueryType } from "../../users/queries/types";
import { GetEmpMasterByNodeId } from "../../users/queries/queries";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../styles/AutocompleteStyles";
import { TextField } from "@mui/material";
import { GetDashboardTicketCount } from "../../DashBoardMapsView/dashboardcomponents/queries";
import ImageIcon from "../../../../../images/DownloadImage.svg";
import VideoPlayer from "../../../../common/VideoPreview";
import TicketReasonSelect from "../../../../../customComponents/TicketReasonSelect";

export interface JunctionDetails {
  name: string;
  subsidiaryName: string;
  suppliername: string;
}
export interface AssetDetail extends IObjectKeys {
  code: string;
  serial_no: string;
  batch: string;
  expiry: string;
  s_date: string;
  e_date: string;
  maintained_by: string;
  geo_location: string;
  asset_location: string;
  installation_date: string;
  desc: string;
  slNo: number;
  name: string;
  id: number;
  img: string;
  companyId: number;
  suppliername: string;
  subsidiaryName: string;
  jType: string;
  arms: number;
  priority: string;
  siteName: string;
  address: string;
}

interface Props {
  assetType: TableType;
  setModalFlag: React.Dispatch<React.SetStateAction<StateTypes>>;
  isItemsView?: boolean;
}

interface UserType {
  kgid: number;
  name: string;
  mobile: string;
  designation: string;
}

const AssetDetailsForTicketing = ({
  setModalFlag,
  assetType,
  isItemsView,
}: Props) => {
  const [browse, setBrowse] = useState(false);

  const [retire, setRetire] = useState(false);
  const [retired, setRetired] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [image, setImage] = useState("");

  const {
    companyLabel,
    itemLabel,
    junctionLabel,
    subsidiaryLabel,
    subsidiarySiteLabel,
  } = useLabels();
  const [assetDetailsModal, setAssetDetailsModal] = useState(false);
  const [videoPreviewModal, setVideoPreviewModal] = useState(false);

  // const [viewTicketDetails, setViewTicketDetails] = useState(false);
  const emptyObject: AssetDetail = {
    code: "",
    serial_no: "",
    batch: "",
    expiry: "",
    s_date: "",
    e_date: "",
    maintained_by: "",
    geo_location: "",
    asset_location: "",
    installation_date: "",
    subsidiaryName: "",
    suppliername: "",
    desc: "",
    id: 0,
    name: "",
    slNo: 0,
    img: "",
    companyId: 0,
    arms: 0,
    jType: "",
    priority: "",
    siteName: "",
    address: "",
  };

  const [assetDetail, setAssetDetail] = useState<AssetDetail>(emptyObject);
  const [junctionDetails, setJunctionDetails] = useState(false);
  const { state, dispatch } = useContext(MapsContext);
  const { state: globalState } = useContext(AppContext);
  const [progress, setProgress] = useState(0);
  const [itemId, setItemdId] = useState(0);
  const [poleNum, setPoleNum] = useState(0);
  const [message, setMessage] = useState<msgType>(emptyMessage);
  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const [file, setFile] = useState<FileList | null>(null);
  const { serverDate } = useServerDateandTime();
  const { no } = useSqlNumber();
  const [mutationFlag, setMutationFlag] = useState(false);
  const [selectedCompaint, setSelectedCompaint] = useState("");
  const [selectedEmp, setSelectedEmp] = useState<responseType | null>(null);
  const [error, setError] = useState("");
  const [user, setUser] = useState<UserType>({
    kgid: 0,
    name: "",
    mobile: "",
    designation: "",
  });

  const [GetEmpById, { data: empData, loading: GetEmpMasterByNodeIdLoading }] =
    useLazyQuery<{ node: EmpMaster }, nodeVar>(GetEmpMasterByNodeId);

  const [addTicket, { loading }] = useMutation<AddTicketResult, AddTicketVars>(
    AddTicket,
    {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
        setMutationFlag(false);
      },
    },
  );

  const [formData, setFormData] = useState<TicketFormType>({
    priority: "",
    reason: "",
    remarks: "",
    status: "",
    ticketDate: "",
    type: "",
    poleNum: 0,
    selectedAsset: true,
  });

  const [GetItemDetails, { data }] = useLazyQuery<
    { node: GetCompOrJuncOrAssetOrSubAndSiteNodeResult },
    GetCompOrJuncOrAssetOrSubAndSiteNodeVars
  >(CompOrJuncOrAssetOrSubAndSiteNode);
  useEffect(() => {
    if (no && serverDate) {
      setFormData({
        ...formData,
        ticketDate: convertToTimeZone(TimeZone.Asia_Kolkata, serverDate)
          .timeAndDate,
        ticketNo: no,
      });
    }
  }, [no, serverDate]);
  useEffect(() => {
    if (
      (isItemsView && state.itemDetailsId) ||
      (!isItemsView && state.assetTypeId)
    ) {
      GetItemDetails({
        variables: {
          id: isItemsView ? state.itemDetailsId : state.assetTypeId,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          let img = "";
          if (assetType === TableType.ASSET)
            img = require(
              `${process.env.React_App_Display_Ticket_Icons}${
                data.node.item.icon ? data.node.item.icon : "item"
              }.svg`,
            );
          else
            img = require(
              `${process.env.React_App_Display_Ticket_Icons}/${
                data.node.icon ? data.node.icon : "Tab"
              }.svg`,
            );
          let slNo = 0;
          if (assetType === TableType.SUBSIDIARY)
            slNo = data.node.currentSubsidiary.slNo;
          let desc = "";
          let siteName = "";
          if (assetType === TableType.ASSET) {
            desc = data.node.item.desc;
            siteName = data.node.currentSite.name;
          } else if (assetType === TableType.JUNCTION) {
            desc = data.node.name;
            siteName = data.node.site.name;
          }

          let companyId = 0;
          if (assetType === TableType.COMPANY) companyId = data.node.id;
          else if (
            assetType === TableType.JUNCTION ||
            assetType === TableType.SUBSIDIARY ||
            assetType === TableType.SITE
          )
            companyId = data.node.companyID;
          else if (assetType === TableType.ASSET)
            companyId = data.node.curCompanyID;

          // else
          //   img = require(`${process.env.React_App_Display_Ticket_Icons}/${
          //     data.node.icon ? data.node.icon : "Tab"
          //   }.svg`);

          setAssetDetail({
            asset_location: EMPTY_STRING,
            batch: data.node.prodBatchNo,
            code: data.node.item
              ? data.node.item.code
              : data.node.code
                ? data.node.code
                : "",
            expiry: toStandardDate(data.node.prodExpiryDate),
            geo_location: `${data.node.prodLatitude},${data.node.prodLongitude}`,
            e_date: toStandardDate(data.node.prodWarrantyEndDate),
            installation_date: toStandardDate(
              data.node.prodInstallationEndDate,
            ),
            maintained_by: "",
            s_date: toStandardDate(data.node.prodWarrantyEndDate),
            serial_no: data.node.prodSerialNo,
            subsidiaryName: "",
            suppliername: "",
            desc,
            id: data.node?.item?.id ? data.node?.item?.id : 0,
            name: "",
            slNo,
            img,
            companyId,
            arms: data.node.arms,
            jType: data.node.jType,
            priority: data.node.priority,
            siteName: siteName,
            address: data.node.address,
          });
        }
      });
    }
  }, [
    state.assetTypeId,
    isItemsView,
    state.itemDetailsId,
    GetItemDetails,
    assetType,
    data,
  ]);

  const handleImagePreview = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      let image_as_files = e.target.files;
      let foundImage = false;
      for (let i = 0; i < image_as_files.length; i++) {
        if (
          allowedFormatsForTicket.includes(image_as_files[i].type.split("/")[1])
        ) {
          foundImage = true;
          break;
        }
      }
      if (foundImage) {
        setFile(image_as_files);
      } else
        setMessage({
          flag: true,
          message: "Selected type of file is not allowed to upload",
          operation: Operation.NONE,
        });
    }
  };

  const handleAddTicket = async () => {
    setMutationFlag(true);
    try {
      // if (!state.asset) {
      //   setMessage({
      //     flag: true,
      //     message: `${itemLabel} Details not found`,
      //     operation: Operation.NONE,
      //   });
      //   return;
      // }

      let filename = "";
      if (file) {
        const files = Object.values(file!);

        filename = files
          ? files.length > 1
            ? files.reduce((acc, itm) => {
                const seperators = itm.name.split("/");

                const filename = seperators[seperators.length - 1];

                acc = acc
                  ? `${acc};${assetDetail.companyId}/ticketDetails/${filename}`
                  : `${assetDetail.companyId}/ticketDetails/${filename}`;
                return acc;
              }, EMPTY_STRING)
            : `${assetDetail.companyId}/ticketDetails/${
                files[0].name.split("/")[files[0].name.split("/").length - 1]
              }`
          : EMPTY_STRING;
      }

      if (customer_id) {
        const addedPromise = addTicket({
          variables: {
            customerID: customer_id,
            user_details,
            input: {
              itemDetailsID:
                assetType === TableType.JUNCTION && state.asset
                  ? state.asset.value
                  : assetType === TableType.ASSET
                    ? state.assetTypeId
                    : 0,
              reason: formData.reason,
              ticketDate: toIsoDate(serverDate),
              remarks: formData.remarks,
              type: "",
              poleNum: formData.poleNum,
              junctionID:
                assetType === TableType.JUNCTION && state.assetTypeId
                  ? state.assetTypeId
                  : 0,
              siteID: 0,
              tableLevel: assetType,

              imagesPath: file ? filename : EMPTY_STRING,
            },
            loggedBy:
              selectedEmp && globalState.empSubType === empType.HELP_DESK
                ? selectedEmp.value
                : 0,

            // Add other necessary variables here
          },
          refetchQueries: [
            {
              query: GetDashboardTicketCount,
              variables: {
                customerID: customer_id ? customer_id : 0,
                empID: user_details.id ? user_details.id : 0,
              },
            },
            {
              query: GetTickets,
              variables: {
                after: null,
                first: ROWS_PER_PAGE,
                name: EMPTY_STRING,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsTicketsOrderField.TICKET_NO,
                },

                companyID: 0,
                customerID: customer_id,
                subsidiaryID: 0,
                junctionID: 0,
                reason: EMPTY_STRING,
                input: {
                  itemID: 0,
                  ldgrID: 0,
                  stckCategoryID: 0,
                  stckGroupID: 0,
                  stckManufacturerID: 0,
                  stckSubCategoryID: 0,
                  stckUomID: 0,
                  query_type: TicketsQueryType.ALL,
                  itemDetailsID:
                    assetType === TableType.ASSET ? state.assetTypeId : 0,
                  status: [
                    TicketStatus.ASSIGNED,
                    TicketStatus.OPEN,
                    TicketStatus.RESOLVED,
                    TicketStatus.RE_OPENED,
                  ],
                  empID: user_details.id!,
                  priority: [],
                },
                siteID: 0,
              },
            },
            {
              query: GetTickets,
              variables: {
                after: null,
                first: ROWS_PER_PAGE,
                name: EMPTY_STRING,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsTicketsOrderField.TICKET_NO,
                },

                companyID: 0,
                customerID: customer_id,
                subsidiaryID: 0,
                junctionID: 0,
                reason: EMPTY_STRING,
                input: {
                  itemID: 0,
                  ldgrID: 0,
                  stckCategoryID: 0,
                  stckGroupID: 0,
                  stckManufacturerID: 0,
                  stckSubCategoryID: 0,
                  stckUomID: 0,
                  query_type: TicketsQueryType.ALL,
                  itemDetailsID:
                    assetType === TableType.ASSET ? state.assetTypeId : 0,
                  status: [TicketStatus.OPEN],
                  empID: user_details.id!,
                  priority: [],
                },
                siteID: 0,
              },
            },
            {
              query: GetDashboardTicketCount,
              variables: {
                customerID: customer_id ? customer_id : 0,
                empID: user_details.id ? user_details.id : 0,
              },
            },
          ],
        });
        addedPromise.then(({ data }) => {
          if (data && data.AddTicket) {
            if (file) {
              const files = Object.values(file!);

              const uploadFilePromise = file
                ? Promise.all(
                    files.map((f, index) =>
                      handleUploadAndDownloadFile(
                        f,
                        file.length > 1
                          ? `${assetDetail.companyId}/ticketDetails/${
                              data.AddTicket.ticketDetails[0].id
                            }_${index}.${
                              f.name.split(".")[f.name.split(".").length - 1]
                            }`
                          : `${assetDetail.companyId}/ticketDetails/${
                              data.AddTicket.ticketDetails[0].id
                            }_0.${
                              f.name.split(".")[f.name.split(".").length - 1]
                            }`,
                        setProgress,
                        false,
                      ),
                    ),
                  )
                : false;
              Promise.all([addedPromise, uploadFilePromise]).then(
                ([sendMsgData]) => {
                  if (sendMsgData) {
                    setFile(null);
                    setMessage({
                      flag: true,
                      message: `Ticket Raised Successfully. Ticket No : ${data.AddTicket.ticketNo}`,
                      operation: Operation.CREATE,
                    });
                    setMutationFlag(false);
                  }
                },
              );
            } else {
              setMessage({
                flag: true,
                message: `Ticket Raised Successfully. Ticket No : ${data.AddTicket.ticketNo}`,
                operation: Operation.CREATE,
              });
              setMutationFlag(false);
            }
          }
        });

        // Handle success (e.g., show a success message, close modal, etc.)
      }

      // else {
      //   setMessage({
      //     flag: true,
      //     message: "Attachment is required",
      //     operation: Operation.NONE,
      //   });
      // }
    } catch (err) {
      console.error(err);
    }
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      setModalFlag({
        flag: false,
        itemId: 0,
        tableLevel: TableType.COMPANY,
      });
    }
    setMessage(emptyMessage);
  };

  const handleClear = () => {
    setFormData({
      ...formData,
      reason: EMPTY_STRING,
      remarks: EMPTY_STRING,
      ticketDate: toIsoDate(serverDate),
      ticketNo: no,
    });

    setSelectedCompaint("");
  };

  const getAssetTypeLabel = useCallback(() => {
    switch (assetType) {
      case TableType.ASSET:
        return itemLabel;
      case TableType.JUNCTION:
        return junctionLabel;
      case TableType.COMPANY:
        return companyLabel;
      case TableType.SUBSIDIARY:
        return subsidiaryLabel;
      case TableType.SITE:
        return subsidiarySiteLabel;
      default:
        return EMPTY_STRING;
    }
  }, [
    assetType,
    itemLabel,
    junctionLabel,
    companyLabel,
    subsidiaryLabel,
    subsidiarySiteLabel,
  ]);

  useEffect(() => {
    if (selectedEmp?.value) {
      GetEmpById({
        variables: {
          id: selectedEmp?.value ? selectedEmp?.value : 0,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setUser({
            kgid: data.node?.kgid,
            name: data.node?.name,
            mobile: data.node?.mobile,
            designation: data.node?.empType,
          });
        }
      });
    }
  }, [GetEmpById, selectedEmp?.value]);

  useEffect(() => {
    setSelectedEmp(null);
    setUser({
      kgid: 0,
      name: "",
      mobile: "",
      designation: "",
    });
  }, [selectedCompaint, assetType]);

  const selectUser = () => {
    return (
      <div>
        {selectedCompaint === "Police" && (
          <div className="label-grid">
            <Label>Metal No / KgId</Label>
            <EmployeeSelect
              onChange={(newValue) => {
                if (newValue) {
                  setSelectedEmp(newValue);
                } else {
                  setSelectedEmp(null);
                }
              }}
              empType={[
                empType.ACP,
                empType.ASI,
                empType.DCP,
                empType.HC,
                empType.JCP,
                empType.PC,
                empType.PSI,
                empType.WASI,
                empType.WHC,
                empType.WPC,
                empType.WPSI,
                empType.HC,
                empType.WHC,
                empType.WASI,
                empType.PMU,
              ]}
              onKeyDown={emptyFunc}
              queryType={EmpQueryType.BY_TYPE}
              value={selectedEmp ? selectedEmp.value : 0}
              label=""
              ldgrId={0}
              kgid={true}
            />
          </div>
        )}

        <div className="label-grid">
          <Label>Name</Label>
          {selectedCompaint === "Vendor" ? (
            <EmployeeSelect
              onChange={(newValue) => {
                if (newValue) {
                  setSelectedEmp(newValue);
                } else {
                  setSelectedEmp(null);
                }
              }}
              empType={[empType.VENDOR_MANAGER]}
              onKeyDown={emptyFunc}
              queryType={EmpQueryType.BY_TYPE}
              value={selectedEmp ? selectedEmp.value : 0}
              label=""
              ldgrId={0}
            />
          ) : (
            <Input value={user.name} disabled />
          )}
        </div>
        <div className="label-grid">
          <Label>Designation</Label>
          <Input value={user.designation} disabled />
        </div>
        <div className="label-grid">
          <Label>Mobile No</Label>
          <Input value={user.mobile} disabled />
        </div>
      </div>
    );
  };

  if (data) {
    return (
      <>
        <div className="maps-item-details__asset">
          <Formik
            initialValues={formData}
            validationSchema={raiseTicketValidation}
            onSubmit={handleAddTicket}
            enableReinitialize
            validateOnChange
          >
            {(meta) => {
              return (
                <Form className="maps-item-details__asset--form">
                  <div className="maps-item-details__asset--form-block">
                    <div className="maps-item-details__asset--h">
                      <div
                        className="maps-item-details__asset--h--flex"

                        // className={
                        //   `maps-item-details__asset--h--flex
                        //   ${data.node.status === TicketPriority.CRITICAL
                        //     ? "border-red"
                        //     : data.node.status === TicketPriority.MEDIUM
                        //     ? "border-yellow"
                        //     : data.node.status === TicketPriority.LOW
                        //     ? "border-green"
                        //     : ""}

                        //     `
                        // }
                      >
                        <img src={assetDetail.img} alt="" />
                        <div>
                          <div>
                            <b className="maps-item-details__asset--h--item">
                              {assetDetail.desc} ({assetDetail.code})
                            </b>{" "}
                            {/* <b className="maps-item-details__asset--h--item">
                              {assetDetail.siteName} 
                            </b>
                            <b className="maps-item-details__asset--h--code">
                            ({assetDetail.code})
                            </b> */}
                            <span>{assetDetail.name}</span>
                          </div>
                          <div>
                            {assetDetail.jType && (
                              <b className="maps-item-details__asset--h--code">
                                jType: {assetDetail.jType}
                              </b>
                            )}
                            {assetDetail.arms && (
                              <b className="maps-item-details__asset--h--code">
                                arms: {assetDetail.arms}
                              </b>
                            )}
                          </div>
                        </div>
                      </div>

                      <CustomTooltip
                        title={`View ${getAssetTypeLabel()} Details`}
                        arrow
                        placement="top"
                        slotProps={{
                          tooltip: {
                            sx: {
                              bgcolor: TOOLTIP_COLORS.VARIABLE,
                              "& .MuiTooltip-arrow": {
                                color: TOOLTIP_COLORS.VARIABLE,
                              },
                            },
                          },
                        }}
                      >
                        <img
                          src={Information}
                          alt=""
                          onClick={() => {
                            if (assetType === TableType.JUNCTION) {
                              return setJunctionDetails(!junctionDetails);
                            } else {
                              setItemdId(assetDetail.id);
                              setAssetDetailsModal(!assetDetailsModal);
                            }
                          }}
                        />
                      </CustomTooltip>
                    </div>

                    {/* <JunctionDetails pageType={pageType === TableType.JUNCTION ? TableType.JUNCTION   : TableType.ASSET}/> */}
                    <div className="search_ticket__asset">
                      <div className="search_ticket__asset--form-block">
                        {/* <JunctionDetails pageType={pageType === TableType.JUNCTION ? TableType.JUNCTION   : TableType.ASSET}/> */}
                        <Title>Raise Ticket</Title>
                        <div className="label-grid">
                          <Label>Ticket Reason</Label>
                          {/* <FormAutocomplete
                            className={formClasses.inputRoot}
                            options={ticketRaiseResonOptions}
                            onKeyDown={emptyFunc}
                            value={formData.reason}
                            openOnFocus
                            forcePopupIcon
                            onChange={(e, newValue) => {
                              if (newValue) {
                                setFormData((prev) => ({
                                  ...prev,
                                  reason: newValue as string,
                                }));
                              } else {
                                setFormData((prev) => ({
                                  ...prev,
                                  reason: "",
                                }));
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                label=""
                                // autoFocus={autoFocus}
                                onChange={(e) => {}}
                                className={formClasses.formControlRoot}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                                placeholder={"Select"}
                              />
                            )}
                          /> */}

                          <TicketReasonSelect
                            onChange={(newValue) => {
                              if (newValue) {
                                setFormData({
                                  ...formData,
                                  reason: newValue,
                                });
                              } else {
                                setFormData({
                                  ...formData,
                                  reason: newValue,
                                });
                              }
                            }}
                            value={formData.reason}
                          />

                          {/* <Input
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                reason: e.target.value,
                              });
                            }}
                            value={formData.reason}
                            required
                          /> */}
                        </div>
                        <div className="label-grid">
                          <Label>Complaint Description</Label>
                          <TextArea
                            rows={3}
                            name="remarks"
                            maxLength={1000}
                            value={formData.remarks}
                            onChange={(e) => {
                              if (/[^a-zA-Z0-9 .,]/g.test(e.target.value)) {
                                setError(
                                  "complaint description cannot contain special characters.",
                                );
                              } else {
                                setFormData({
                                  ...formData,
                                  remarks: e.target.value,
                                });
                                setError("");
                              }
                            }}
                            required
                          />

                          <span />
                          {error && <span className="nodata">{error}</span>}
                        </div>
                      </div>
                    </div>
                    {globalState.empSubType === empType.HELP_DESK ? (
                      <>
                        <div className="label-grid">
                          <Label>Compaint Given By</Label>
                          <FormAutocomplete
                            className={formClasses.inputRoot}
                            options={["Police", "Vendor", "Others / Public"]}
                            onKeyDown={emptyFunc}
                            value={selectedCompaint}
                            openOnFocus
                            forcePopupIcon
                            // getOptionLabel={(option) =>
                            //   (option as AtsCompanyEdge).node.name
                            // }
                            // slotProps={{
                            //   listbox: {
                            //     onScroll: handleScroll,
                            //   },
                            // }}
                            onChange={(e, newValue) => {
                              if (newValue) {
                                setSelectedCompaint(newValue as string);
                              } else {
                                setSelectedCompaint("");
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                label=""
                                // autoFocus={autoFocus}
                                onChange={(e) => {}}
                                className={formClasses.formControlRoot}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                                placeholder={"Select"}
                              />
                            )}
                          />
                        </div>
                        {selectedCompaint === "Police" ||
                        selectedCompaint === "Vendor"
                          ? selectUser()
                          : ""}
                      </>
                    ) : (
                      ""
                    )}
                    <div className="label-grid">
                      <Label>Attachments</Label>
                      <div className="items__add--form--flex">
                        {/* <Input value={file?.name} disabled /> */}
                        {!browse ? (
                          <>
                            <label className="items__add--form--details--browse">
                              <img
                                src={FileAttach}
                                alt="/"
                                className="browse-icon"
                              />
                              Browse
                              <input
                                id="student-documents__browse--inputTag"
                                type="file"
                                className="assignment-creation__fileattach--input"
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  handleImagePreview(e);
                                  setBrowse(!browse);
                                }}
                                accept={allowedFormatsForTicket.join(", ")}
                                security="strict"
                              />
                            </label>{" "}
                          </>
                        ) : (
                          <>
                            <button className="items__add--form--details--upload">
                              <img src={Upload} alt="" />
                              Upload
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                    {/* <div className="label-grid">
            <Label>Attachments</Label>
                  <div className="raise-ticket__form--files">
                    <>
                      {selectedFiles && selectedFiles.length > 0 ? (
                        <ul className="raise-ticket__form--files--ul">
                          {Array.from(selectedFiles).map((file, index) => (
                            <li
                              className="raise-ticket__form--files--li"
                              key={index}
                            >
                              <span>{file.name}</span>{" "}
                              <img src={Close} alt="" />
                            </li>
                          ))}
                          <li className="raise-ticket__form--files--more">
                            {" "}
                            + Choose One More File Here
                          </li>
                        </ul>
                      ) : (
                        <div className="raise-ticket__form--choose-files">
                          <div
                            onClick={() =>
                              document.getElementById("fileInput")?.click()
                            }
                          >
                            <img src={ChooseFile} alt="" />
                            <span>Choose File(s) or Folder to Upload</span>
                            <input
                              type="file"
                              id="fileInput"
                              style={{ display: "none" }}
                              accept=".jpeg,.jpg,.png"
                              onChange={handleFileChange}
                              multiple
                            />
                          </div>
                        </div>
                      )}
                    </>

                    <div className="raise-ticket__form--files--footer">
                      Please upload file(max file size:5MB, Only Jpeg,jpg and
                      png allowed)
                    </div>
                  </div>
            </div> */}
                    <div className="label-grid">
                      <span></span>{" "}
                      {file && file.length > 0 ? (
                        <div
                          onClick={async () => {
                            let img = "";

                            if (file) {
                              const files = file[0].name.split(".");

                              const ext = files.length
                                ? files[files.length - 1]
                                : EMPTY_STRING;

                              try {
                                const ext = file[0].name.split(".").pop();
                                setImage(URL.createObjectURL(file[0]));
                                if (imageFormats.includes(ext!)) {
                                  setImageModal(!imageModal);
                                } else setVideoPreviewModal(!videoPreviewModal);
                              } catch (err) {
                                console.error(err as Error);
                              }
                            }
                          }}
                        >
                          <img
                            src={ImageIcon}
                            alt=""
                            className="junc-follow-up__data--remarks--flex--view"
                          />
                          {file[0].name.split("/").pop()}
                          <CustomModal
                            isOpen={imageModal}
                            onRequestClose={() => setImageModal(!imageModal)}
                            contentComponent={
                              <>
                                <div className="edit-vendor-response__title">
                                  <Title>Image details</Title>
                                  <img
                                    src={Close}
                                    alt=""
                                    onClick={() => setImageModal(!imageModal)}
                                  />
                                </div>
                                {image && (
                                  <div
                                    className={`junc-follow-up__data--remarks--flex--image-container "open" : ""
                                }`}
                                  >
                                    <img
                                      className="junc-follow-up__data--remarks--flex--image"
                                      src={image}
                                      alt=""
                                    />
                                  </div>
                                )}
                              </>
                            }
                            style={ImageModalStylesInTickets}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="maps-item-details__asset--flex">
                    <div>
                      <Button
                        mode="raise"
                        type="submit"
                        loading={loading || mutationFlag}
                        disabled={formData.remarks === EMPTY_STRING}
                      >
                        Ticket
                      </Button>
                      <Button
                        mode="clear"
                        onClick={() => {
                          handleClear();
                        }}
                      ></Button>

                      <Button
                        mode="cancel"
                        type="button"
                        loading={loading || mutationFlag}
                        onClick={() =>
                          setModalFlag({
                            flag: false,
                            itemId: 0,
                            tableLevel: TableType.CUSTOMER,
                          })
                        }
                      />
                    </div>
                    {assetType === TableType.JUNCTION && <Legends />}
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
        <Modal
          isOpen={retire}
          onRequestClose={() => setRetire(!retire)}
          style={WaiveOffModalStyles}
        >
          <div className="maps-retire">
            <div className="maps-retire__title">
              <Title variant="subtitle1">
                <img src={Warning} alt="" /> Do you want to Retire
              </Title>
              <img
                src={Close}
                alt=""
                className="maps-retire__title--close"
                onClick={() => setRetire(!retire)}
              />
            </div>
            <Label> Make Sure {itemLabel} is going to retire</Label>
            <div>
              <Button
                mode="yes"
                onClick={() => {
                  setRetired(!retired);
                  setRetire(!retire);
                }}
              />
              <Button mode="no" onClick={() => setRetire(!retire)} />
            </div>
          </div>
        </Modal>

        <CustomModal
          isOpen={assetDetailsModal}
          onRequestClose={() => setAssetDetailsModal(!assetDetailsModal)}
          contentComponent={
            <ViewAsset setModalFlag={setAssetDetailsModal} itemId={itemId} />
          }
          style={ViewTicketModalStyles}
        />

        {/* <CustomModal
          isOpen={viewTicketDetails}
          onRequestClose={() => setViewTicketDetails(!viewTicketDetails)}
          contentComponent={
            <ViewTicketDetails setModalFlag={setViewTicketDetails} />
          }
          style={ViewTicketModalStyles}
        /> */}

        <MessageModal
          handleClose={handleClose}
          modalFlag={message.flag}
          operation={message.operation}
          value={message.message}
        />
        <AssetViewDrawer
          anchor="right"
          open={junctionDetails}
          onClose={() => setJunctionDetails(!junctionDetails)}
        >
          <ViewJunctionDetails setModalFlag={setJunctionDetails} />
        </AssetViewDrawer>
        <LoadingModal flag={mutationFlag} />
        <CustomModal
          isOpen={videoPreviewModal}
          onRequestClose={() => setVideoPreviewModal(!videoPreviewModal)}
          contentComponent={
            <VideoPlayer
              posterSrc=""
              videoSrc={image}
              setModal={setVideoPreviewModal}
            />
          }
          style={VideoPreviewModalStyles}
        />
      </>
    );
  } else {
    return <b className="nodata">{itemLabel} not found</b>;
  }
};

export default AssetDetailsForTicketing;
